import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import FarewellPage from "./pages/FarewellPage";

const App = () => (
  <HelmetProvider>
    <BrowserRouter>
      <Helmet>
        <title>¡Hasta la vista! - OAKMAN</title>
      </Helmet>
      <Routes>
        <Route path="*" element={<FarewellPage />} />
      </Routes>
    </BrowserRouter>
  </HelmetProvider>
);

export default App;
